import React from "react";

const Dining = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="16 55 170 101"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="16 55 170 101"
      role="img"
      className="content-card__svg"
    >
      <g>
        <rect x="16" y="151" width="170" height="5"></rect>
        <path
          d="M180.1,142.2C176.1,103,143,72.3,104,71V60h9.6c1.5,0,2.7-1,2.7-2.5c0-1.5-1.2-2.5-2.7-2.5H88.3c-1.5,0-2.7,1-2.7,2.5
	c0,1.5,1.2,2.5,2.7,2.5H98v11c-39,1.4-72.1,32.1-76.1,71.3l-0.2,2.8h158.5L180.1,142.2z M27.7,140c5.2-36,36.8-63.7,73.3-63.7
	S169,104,174.2,140H27.7z"
        ></path>
        <path
          d="M57.2,116.9c-0.5,0-1.1-0.2-1.5-0.5c-1.2-0.9-1.5-2.5-0.6-3.7c6.3-9,14.9-15.6,24.7-19c1.4-0.5,2.9,0.3,3.4,1.7
	c0.5,1.4-0.3,2.9-1.7,3.4c-8.8,3-16.4,8.9-22.1,17C58.9,116.5,58,116.9,57.2,116.9z"
        ></path>
      </g>
    </svg>
  );
};

export default Dining;
